import { Injectable, signal } from '@angular/core';

/** Contexto del módulo activo del rail/dock (para eyebrow de la page bar). */
@Injectable({ providedIn: 'root' })
export class AdminNavContextService {
  private readonly _moduleLabel = signal<string | null>(null);
  private readonly _showEyebrow = signal(false);

  readonly moduleLabel = this._moduleLabel.asReadonly();
  readonly showEyebrow = this._showEyebrow.asReadonly();

  setModuleContext(label: string | null, showEyebrow: boolean): void {
    this._moduleLabel.set(label?.trim() || null);
    this._showEyebrow.set(!!showEyebrow && !!label?.trim());
  }

  clear(): void {
    this._moduleLabel.set(null);
    this._showEyebrow.set(false);
  }
}
